import React, { useState, useEffect } from "react";
import "./Navbar.css";
import { FaBars } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { postInformationToDiscord } from "../../action/HomePage.action";
import { Link, useNavigate } from "react-router-dom";
import CustomModal from "../modal/Modal";
import Button from "../Button/Button";

const GOOGLE_SHEETS_SCRIPT_URL =
  "https://script.google.com/macros/s/AKfycbzvO8h7eHRZOhqnUSRPsMYg6knbLixJNkkdgFoOQuAmXqQE6dhs0K1kSNEt2kSz227OEA/exec";

const Navbar = ({ showJoinUs = true, withTopSpacing = true }) => {
  const [colorChange, setColorchange] = useState(false);
  const [isToggled, setIsToggled] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [modalData, setModalData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });
  const [showThankYou, setShowThankYou] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const heroSection = document.querySelector(".hero");
    const heroHeight = heroSection?.offsetHeight || 580;

    const changeNavbarColor = () => {
      setColorchange(window.scrollY >= heroHeight);
    };

    window.addEventListener("scroll", changeNavbarColor);
    return () => {
      window.removeEventListener("scroll", changeNavbarColor);
    };
  }, []);

  const submitToGoogleSheets = async (data) => {
    const body = new URLSearchParams({
      sheetName: "Book a Demo",
      FirstName: data.firstName,
      LastName: data.lastName,
      Email: data.email,
      Phone: data.phone,
      Message: data.message
    });

    await fetch(GOOGLE_SHEETS_SCRIPT_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      },
      body
    });
  };

  const handleFormSubmit = async (formData) => {
    if (!formData.email) {
      alert("Please fill out email id before submitting.");
      return;
    }
    try {
      await dispatch(postInformationToDiscord(formData));
      await submitToGoogleSheets(formData);
      setShowThankYou(true);
      setModalData({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        message: "",
      });
      setTimeout(() => {
        setShowThankYou(false);
      }, 9000);
    } catch (error) {
      console.error("Error submitting demo request:", error);
    }
  };

  return (
    <>
      <nav
        id="navbar-id"
        className={`navbar navbar-expand-lg navbar-light fixed-top navbar_two 
          ${colorChange ? "colorChange_two" : ""} 
          ${withTopSpacing ? "" : "no-top-preview"}`}
      >
        <div
          className={isToggled ? "nav-bg container-fluid" : "container-fluid"}
        >
          <Link
            to="/"
            className="navbar-brand_two text-white"
            onClick={() => window.scrollTo(0, 0)}
          >
            <img
              src={require("../../assets/terafac_logo1.png")}
              alt="Terafac Logo"
              draggable="false"
              width="80"
              height="80"
              className="d-inline-block align-text-center rounded-circle"
            />
          </Link>

          <button
            className="navbar-toggler bg-white"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
            onClick={() => setIsToggled(!isToggled)}
          >
            <FaBars />
          </button>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Button
                  text="Book a Demo"
                  size="discord"
                  color="black"
                  type="button"
                  data-bs-toggle="modal"
                  data-bs-target="#staticBackdrop"
                  className="fs-6"
                />
              </li>
              {showJoinUs && (
                <li className="nav-item" onClick={() => navigate("/career")}>
                  <Button
                    text="Join Us"
                    size="discord"
                    color="black"
                    type="button"
                    className="fs-6"
                  />
                </li>
              )}
            </ul>
          </div>
        </div>
      </nav>

      <CustomModal
        modalTitle="Book Demo Now"
        closeButtonName="Close"
        actionButtonName="Book Demo"
        onClose={() => setIsToggled(false)}
        onSubmit={handleFormSubmit}
        formData={modalData}
        setFormData={setModalData}
      />

      {showPopup && (
        <div className="email-popup">
          <div className="email-popup-content">
            <button
              className="email-close-button"
              onClick={() => setShowPopup(false)}
            >
              &times;
            </button>
            <p className="thank-you-message">
              Thank you for requesting a demo. We will get back to you soon.{" "}
              <br />
              Meanwhile, talk to our manufacturing expert.
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
